<div class="app-content {{ componentClass }}" [ngClass]="{ 'fullscreen': isFullscreen, 'swiped-header': swipedHeader }">
  <!-- <app-header></app-header> -->
  <main role="main">
      <router-outlet></router-outlet>
  </main>
  <!-- <app-footer></app-footer> -->
</div>
<ngx-loading [show]="loading"></ngx-loading>